import strengthTitle from '../../../../../images/strengthTitle.png';
import weaknessTitle from '../../../../../images/weaknessTitle.png';
import opportunityTitle from '../../../../../images/opportunityTitle.png';
import threatTitle from '../../../../../images/threatTitle.png';

export const swot_category_data_0 = [
    {
        link: '/',
        icon: strengthTitle,
        background_color: 'linear-gradient(to right, #d3ef77 , #afef9a)',
        heading: 'STRENGTH',
        discription: 'Optionally skilled Areas',
        children: [
            {
                link: '/',
                name: 'Acceptance',
            },
            {
                link: '/',
                name: 'Acceptance',                           
            },
            {
                link: '/',
                name: 'Acceptance',                            
            }
        ]
    },
    {
        link: '/',
        icon: weaknessTitle,
        heading: 'WEAKNESS',
        background_color: 'linear-gradient(to right, #f3cba1 , #f2cdc4)',
        discription: 'Optionally skilled Areas',
        children: [
            {
                link: '/',
                name: 'Acceptance',                           
            },
            {
                link: '/',
                name: 'Acceptance',                          
            },
            {
                link: '/',
                name: 'Acceptance',                            
            }
        ]
    },
    {
        link: '/',
        icon: opportunityTitle,
        heading: 'OPPORTUNITY',
        background_color: 'linear-gradient(to right, #d6d9f2 , #a7ccce)',
        discription: 'Optionally skilled Areas',
        children: [
            {
                link: '/',
                name: 'Acceptance',                            
            },
            {
                link: '/',
                name: 'Acceptance',
                
            },
            {
                link: '/',
                name: 'Acceptance',                          
            }
        ]
    },
    {
        link: '/',
        heading: 'TREAT',
        icon: threatTitle,
        background_color: 'linear-gradient(to right, #fff6a3 , #f7d7a1)',
        discription: 'Optionally skilled Areas',
        children: [
            {
                link: '/',
                name: 'Acceptance',                          
            },
            {
                link: '/',
                name: 'Acceptance',                          
            },
            {
                link: '/',
                name: 'Acceptance',                        
            }
        ]
    }
]

export const swot_category_data_1 = [
    {
        link: '/',
        icon: strengthTitle,
        background_color: 'linear-gradient(to right, #d3ef77 , #afef9a)',
        height:320,
        key: 'strength',
        heading: 'STRENGTH',
        discription: 'Optionally skilled Areas',
        children: [
            {
                link: '/',
                name: 'Ownership',
                footer_text: 'Ownership Orientation',
                discription: 'The group members are self-driven and results-oriented. They are hard workers. They step up their efforts when needed and work their way through challenges to achieve the set goals.'
            }
        ]
    },
    {
        link: '/',
        icon: weaknessTitle,
        key: 'weakness',
        heading: 'WEAKNESS',
        background_color: 'linear-gradient(to right, #f3cba1 , #f2cdc4)',
        discription: 'Optionally skilled Areas',
        children: [
            {
                link: '/',
                name: 'Time sense',
                footer_text: 'Ownership Orientation',
                discription: "The group members don't seem to understand the relevance of their decisions to the prevailing context. Due to bad timing, they miss may opportunities and struggle to achieve the set goals despite doing the right things and working hard."                     
            }
            
        ]
    },
    {
        link: '/',
        icon: opportunityTitle,
        heading: 'OPPORTUNITY',
        key:'opportunity',
        background_color: 'linear-gradient(to right, #d6d9f2 , #a7ccce)',
        discription: 'Optionally skilled Areas',
        children: [
            {
                link: '/',
                name: 'Acceptance',
                footer_text: 'Ownership Orientation',
                discription: "Help them further leverage their detail-orientation to enhance their quality of execution. Set challenging targets to bring down the number of error scenarios or the need for rework when the group executes an idea."                         
            }
        ]
    },
    {
        link: '/',
        heading: 'TREAT',
        key: 'threat',
        icon: threatTitle,
        background_color: 'linear-gradient(to right, #fff6a3 , #f7d7a1)',
        discription: 'Optionally skilled Areas',
        children: [
            {
                link: '/',
                name: 'Acceptance',
                footer_text: 'Ownership Orientation',
                discription: "The group members may over-estimate their abilities and take on more than what they can handle. They tend to get carried away by new ideas and possibilities rather than focus on the task at hand. They are likely to have unrealistic expectations from one another."                         
            }
        ]
    }
]

export const swot_para_category_data_1 = [
    {
        link: '/',
        icon: strengthTitle,
        background_color: 'linear-gradient(to right, #d3ef77 , #afef9a)',
        height:320,
        key: 'strength',
        heading: 'STRENGTH',
        discription: 'Optionally skilled Areas',
        children: [
            {
                link: '/',
                name: 'Ownership',
                footer_text: 'Ownership Orientation',
                discription: 'The group members are self-driven and results-oriented. They are hard workers. They step up their efforts when needed and work their way through challenges to achieve the set goals.'
            },
            {
                link: '/',
                name: 'Ownership',
                footer_text: 'Ownership Orientation',
                discription: 'The group members are self-driven and results-oriented. They are hard workers. They step up their efforts when needed and work their way through challenges to achieve the set goals. through challenges to achieve the set goals.'
            },
            {
                link: '/',
                name: 'Ownership',
                footer_text: 'Ownership Orientation',
                discription: 'The group members are self-driven and results-oriented. They are hard workers. They step up their efforts when needed and work their way through challenges to achieve the set goals.'
            }
        ]
    },
    {
        link: '/',
        icon: weaknessTitle,
        key: 'weakness',
        heading: 'WEAKNESS',
        background_color: 'linear-gradient(to right, #f3cba1 , #f2cdc4)',
        discription: 'Optionally skilled Areas',
        children: [
            {
                link: '/',
                name: 'Time sense',
                footer_text: 'Ownership Orientation',
                discription: "The group members don't seem to understand the relevance of their decisions to the prevailing context. Due to bad timing, they miss may opportunities and struggle to achieve the set goals despite doing the right things and working hard."                     
            },
            {
                link: '/',
                name: 'Ownership',
                footer_text: 'Ownership Orientation',
                discription: 'The group members are self-driven and results-oriented. They are hard workers. They step up their efforts when needed and work their way through challenges to achieve the set goals.'
            },
            {
                link: '/',
                name: 'Ownership',
                footer_text: 'Ownership Orientation',
                discription: 'The group members are self-driven and results-oriented. They are hard workers. They step up their efforts when needed and work their way through challenges to achieve the set goals.'
            }
            
        ]
    },
    {
        link: '/',
        icon: opportunityTitle,
        heading: 'OPPORTUNITY',
        key:'opportunity',
        background_color: 'linear-gradient(to right, #d6d9f2 , #a7ccce)',
        discription: 'Optionally skilled Areas',
        children: [
            {
                link: '/',
                name: 'Acceptance',
                footer_text: 'Ownership Orientation',
                discription: "Help them further leverage their detail-orientation to enhance their quality of execution. Set challenging targets to bring down the number of error scenarios or the need for rework when the group executes an idea."                         
            },
            {
                link: '/',
                name: 'Ownership',
                footer_text: 'Ownership Orientation',
                discription: 'The group members are self-driven and results-oriented. They are hard workers. They step up their efforts when needed and work their way through challenges to achieve the set goals.'
            },
            {
                link: '/',
                name: 'Ownership',
                footer_text: 'Ownership Orientation',
                discription: 'The group members are self-driven and results-oriented. They are hard workers. They step up their efforts when needed and work their way through challenges to achieve the set goals.'
            }
        ]
    },
    {
        link: '/',
        heading: 'TREAT',
        key: 'threat',
        icon: threatTitle,
        background_color: 'linear-gradient(to right, #fff6a3 , #f7d7a1)',
        discription: 'Optionally skilled Areas',
        children: [
            {
                link: '/',
                name: 'Acceptance',
                footer_text: 'Ownership Orientation',
                discription: "The group members may over-estimate their abilities and take on more than what they can handle. They tend to get carried away by new ideas and possibilities rather than focus on the task at hand. They are likely to have unrealistic expectations from one another."                         
            },
            {
                link: '/',
                name: 'Ownership',
                footer_text: 'Ownership Orientation',
                discription: 'The group members are self-driven and results-oriented. They are hard workers. They step up their efforts when needed and work their way through challenges to achieve the set goals.'
            },
            {
                link: '/',
                name: 'Ownership',
                footer_text: 'Ownership Orientation',
                discription: 'The group members are self-driven and results-oriented. They are hard workers. They step up their efforts when needed and work their way through challenges to achieve the set goals.'
            }
        ]
    }
]




// WEBPACK FOOTER //
// ./src/_pages/Organzation/Analyze/Category/SWOT/SwotCatagoryData.js